






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'AppNavbarSidebarToggle',
})
export default class AppNavbarSidebarToggle extends Vue {
  public static sidebarToggleEvent = 'sidebar-toggle';

  @Prop({ default: false }) private isClosed!: boolean;

  get sidebarToggleEvent() {
    return AppNavbarSidebarToggle.sidebarToggleEvent;
  }
}
